export const applyNowContent ={
  title: {
    text: 'Get in touch today',
    dic: 'Get in touch today',
  },
  subTitle: {
    text: 'Our customer service representatives are happy to help 24/7',
    dic: 'Our customer service',
  },
  channelsConfig: [
    {
      name: 'messenger',
      prefix: "https://m.me/",
      icon: 'icon-facebook-messenger',
      target: '_blank',
      dic: 'Messenger',
    },
    {
      name: 'whatsapp',
      prefix: "https://wa.me/",
      icon: 'icon-whatsapp',
      target: '_blank',
      dic: 'Whatsapp',
    },
    {
      name: 'sms',
      prefix: "sms:",
      icon: 'icon-chat',
      dic: 'SMS',
    },
    {
      name: 'call',
      prefix: "tel:",
      icon: 'icon-call',
      dic: 'Call'
    },
    {
      name: 'facetime',
      prefix: 'facetime://',
      icon: 'icon-video-call',
      dic: 'Facetime'
    },
    {
      name: 'email',
      prefix: "mailto:",
      icon: 'icon-email',
      dic: 'Email',
    },
    {
      name: 'appointment',
      prefix: "",
      icon: 'icon-meeting',
      dic: 'Appointment'
    },
  ]
};